module.exports = __webpack_public_path__ + "img/pergola-over-door.1e254fb5.webp";